import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ApplicationButton,
  ApplicationPage,
  ApplicationStateRegion,
  ApplicationSurface,
  ApplicationViewHeader,
} from "../../../components/application";
import { listOwnedAssignments } from "../services/assignmentApi";
import {
  assignmentLifecycleLabel,
  assignmentLifecycleTone,
  formatAssignmentDate,
  targetLabel,
} from "./assignmentViewUtils";
import "./assignmentPresentation.css";

export default function FacilitatorAssignmentsPage() {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    listOwnedAssignments()
      .then((rows) => {
        if (active) setAssignments(rows);
      })
      .catch(() => {
        if (active) setError("Assignments could not be loaded. Please try again.");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  if (loading) {
    return <ApplicationPage variant="workspace"><ApplicationViewHeader contextLabel="Assignments" title="Loading assignments..." /></ApplicationPage>;
  }

  return <ApplicationPage variant="workspace">
    <ApplicationViewHeader
      contextLabel="Assignments"
      title="Facilitator assignments"
      description="Create and manage asynchronous assignments built from ready activities."
    />
    <div className="av-app-form-actions">
      <ApplicationButton onClick={() => navigate("/app/assignments/new")}>Create assignment</ApplicationButton>
    </div>
    {error ? <ApplicationStateRegion status="error" message={error} /> : null}
    <ApplicationSurface>
      <h2>Your assignments</h2>
      {assignments.length === 0 ? <ApplicationStateRegion status="empty" message="No assignments yet." /> :
        <div className="app-table-container"><table className="app-table av-assignment-table">
          <thead><tr><th>Title</th><th>Activity</th><th>Status</th><th>Due</th><th>Open</th></tr></thead>
          <tbody>{assignments.map((assignment) => <tr key={assignment._id}>
            <td data-label="Assignment">{assignment.title}</td>
            <td data-label="Activity">{targetLabel(assignment.target)}</td>
            <td data-label="Status"><span className={["av-app-status-chip", `av-app-status-chip--${assignmentLifecycleTone(assignment.lifecycleStatus)}`].join(" ")}>{assignmentLifecycleLabel(assignment.lifecycleStatus)}</span></td>
            <td data-label="Due">{formatAssignmentDate(assignment.dueAt)}</td>
            <td data-label="Open" className="av-assignment-table__action"><Link className="av-app-button av-app-button--secondary av-app-button--compact" to={`/app/assignments/${assignment._id}`}>View</Link></td>
          </tr>)}</tbody>
        </table></div>}
    </ApplicationSurface>
  </ApplicationPage>;
}
